import { environment } from "../../../../environments/environment";

const BASE_URL = environment.baseUrl;
const AUTH_URL = BASE_URL + 'auth';
const REPORTS_URL = BASE_URL + 'reports';
const SCHEDULER_URL = BASE_URL + 'scheduler';
const TRIPS_URL = BASE_URL + 'trip'
const CUSTOMER_URL = BASE_URL + 'customer';
const DEVICE_URL = BASE_URL + 'device';
const INCIDENTS_URL = BASE_URL + 'incident';
const USER_URL = BASE_URL + 'user';
const NOTIFICATION_URL = BASE_URL + 'notification';
const ADMIN_URL = BASE_URL + 'admin/api/admin';
const ASSET_URL = BASE_URL + 'asset';

// export const API_ENDPOINTS = {
//     AUTH: {
//         LOGIN: 'auth/user-sign-in',
//         VERIFY_FORGET_EMAIL: 'user/check-user-emailForSendOtp',
//         VERIFY_FORGET_OTP: 'user/verify-otp-at-forgot-pass',
//         RESEND_FORGET_OTP: 'user/resend-otp-at-forgot-email',
//         TF_OTP: 'auth/user-verify-otp',
//         RESEND_TF_OTP: 'auth/user-resend-otp',
//         UPDATE_PASSWORD: 'user/update-password-v2',
//         VERIFY_PASSWORD: 'incident/comparePassword',
//     },
//     ASSETS: {
//         LIST: 'asset/get-assets-with-filters',
//         LIST_BY_LOCATION: 'asset/get-asset-by-location',
//         // FILTER_LIST: 'asset/get-all-filter',
//         ADD_ASSET: 'asset/add-assets_v2',
//         UPDATE_ASSET: 'asset/update-asset_v2',
//         ENVIRONMENT_BY_LOCATION_ID: 'asset/get-asset-env',
//         ENVIRONMENT_BY_CUSTOMER_ID: 'env/get-all-env',
//         MAKE_BY_LOCATION_ID: 'asset/get-asset-make',
//         MODEL_BY_LOCATION_ID: 'asset/get-asset-model',
//         TAG_BY_LOCATION_ID: 'asset/get-asset-tag',
//         GET_ASSET_BY_ID: (id: string) => `asset/get-asset-by-id_v2/${id}`,
//         TODAYS_GRAPH_DATA: 'asset/get-today-graph-data_v2',
//         YESTERDAY_GRAPH_DATA: 'asset/get-yesterday-graph-data_v2',
//         WEEK_GRAPH_DATA: 'asset/get-week-graph-data_v2',
//         MONTH_GRAPH_DATA: 'asset/get-month-graph-data_v2',
//         GET_GRAPH_DATA_BY_DATE_RANGE: 'asset/get-graph-between-date-data_v2',
//         GET_ALL_SENSOR_CERTIFICATE: 'device/view-calibration-data',
//         SWAP_SENSOR: 'sensor/swap-sensor_v2',
//         DECOMMISSION_ASSET: 'asset/decommission-asset',
//         DOWNLOAD_EXCEL: 'asset/getSensorExcelData',
//         ALARM: {
//             GET_ALARMS_BY_ASSET: 'alarm/get-alarm-by-asset_v2',
//             ADD_ALARM: 'alarm/add-alarm_v2',
//             UPDATE_ALARM: 'alarm/update-alarm_v2',
//             DELETE_ALARM: 'alarm/delete-alarm_v2',
//             ENABLE_DISABLE_ALARM: 'alarm/alarm-enable-disable',
//         }
//     },
//     INCIDENTS: {
//         LIST: 'incident/get-all-incident',
//         ACKNOWLEDGE: 'incident/incident-acknowledgedment',
//         ASSIGN: 'incident/update-incident-assigned',
//         STATUS_UPDATE: 'incident/update-status',
//         BY_ID: {
//             DATA: 'incident/get-incident-by-id',
//             HISTORY: 'incident/get-incident-log',
//             FORM_DATA: 'admin/get-incidentTabs-data',
//             TR_FORM_DATA: '/incident/tab-data',
//             LOGS: 'incident/get-incident-detail-log',
//             TR_LOGS: 'incident/get-incident-details-log',
//             GRAPH_DATA: 'incident/get-incidentGraph-dateData'
//         },
//         FORM: {
//             EXCURSION_LIST: 'admin/get-excursion-reason-list',
//             SUBMIT_INC_DETAILS: 'incident/add-affected-product-list',
//             SUBMIT_CAPA_DETAILS: 'incident/add-invCapaDetails',
//             SUBMIT_EVAL_DETAILS: 'incident/add-evalDispDetails',
//             UPDATE_EVAL_PROD_LIST: 'incident/update-evalDisProdList',
//             UPLOAD_CAPA_FILE: 'admin/upload-capa-doc',
//             DOWNLOAD_CAPA_FILE: 'admin/download-capa-file',
//             COMMENT: 'incident/add-comments',
//             REJECTED_DETAILS: 'incident/get-rejected-form-data',
//             ACTION: {
//                 FIRST_TAB: 'incident/firstTabAction',
//                 TR_FIRST_TAB: 'incident/first-tab-action',
//                 SECOND_TAB: 'incident/secondTabAction',
//                 THIRD_TAB: 'incident/thirdTabAction',
//                 FINAL_TAB: 'incident/finalTabAction',
//                 RESUBMIT: 'incident/reset-form'
//             }
//         }
//     },
//     ADMIN: {
//         GROUP_MANAGEMENT: {
//             UPDATE_LOCATION: 'groupzone/updateLocation',
//         },
//         DEVICE_MANAGEMENT: {
//             AVAILABLE_DEVICES: 'sensor/get-all-whitelistingData',
//             GATEWAY: {
//                 LIST: 'gateway/get-gateway',
//                 DATA_BY_ID: 'gateway/get-gateway-by-id',
//                 CREATE: 'gateway/add-gateway',
//                 UPDATE: 'gateway/update-gateway',
//                 DELETE: 'gateway/delete-gateway',
//                 LOGS: 'device/device-logs'
//             },
//             SENSOR: {
//                 LIST_BY_ASSET_ID: 'sensor-data/getSensorbyAssetID',
//                 LIST: 'sensor/get-all-active-sensor-by-group-id',
//                 DATA_BY_ID: 'sensor/get-sensor-by-id',
//                 CREATE: 'sensor/add-sensor_v2',
//                 UPDATE: 'sensor/update-sensor_v2',
//                 DELETE: 'sensor/delete-sensor-by-id',
//                 LOGS: 'device-logs'
//             },
//             HOOTER: {
//                 LIST: 'sensor/get-all-active-hooter-by-group-id',
//                 DATA_BY_ID: 'hooter/get-hooter-by-id',
//                 CREATE: 'hooter/add-hooter',
//                 UPDATE: 'hooter/update-hooter-by-id',
//                 DELETE: 'hooter/delete-hooter-by-id'
//             }
//         },
//     },
//     UTILITY: {
//         COMPARE_PASSWORD: 'incident/comparePassword',
//     },
//     PROFILE: {
//         ADD_SUPPORT_TICKET: 'support/addSupportTicket',
//         GET_RECENT_TICKET: 'support/getSupportTicket',
//         USER_LOG: 'user/adduserLog',
//         DEMO_VIDEOS: 'demovideos/getDemoVideo'
//     },
// }

export const NOTIFICATION = {
    GET_ALL: NOTIFICATION_URL + '/notification-center',
    MARK_READ: NOTIFICATION_URL + '/notification-center',
}

export const REPORTS = {
    DEVICE_REPORT: REPORTS_URL + '/get-device-report',
    INCIDENT_REPORT: REPORTS_URL + '/get-incident-summary-report',
    AUDIT_REPORT: REPORTS_URL + '/get-audit-summary-report',
    ASSET_REPORT: REPORTS_URL + '/get-asset-summary-report',
    DAILY_REPORT: REPORTS_URL + '/get-daily-summary-report',
    TRIP_SUMMARY_REPORT: REPORTS_URL + '/get-trip-report',
    TRANSPORTER_REPORT: REPORTS_URL + '/get-transporter-report',
    SIGN_AND_SUBMIT_REPORT: REPORTS_URL + '/sign-and-submit',
    GET_REPORTS: REPORTS_URL + '/get-reports',
    GET_DASHBOARD_DATA: REPORTS_URL + '/dashboard',
    DISPATCH_DELAY_REPORT: REPORTS_URL + '/get-dispatch-delay-report',
    TRANSPORT_INCIDENT_REPORT: REPORTS_URL + '/get-transport-incident-report',
}

export const SCHEDULER = {
    GET_REPORT: SCHEDULER_URL + '/report',
    ADD_REPORT: SCHEDULER_URL + '/report',
    DELETE_REPORT: (name: string) => SCHEDULER_URL + '/report/' + name,
}

export const TRIPS = {
    GET_TRIPS: TRIPS_URL + '/',
    GET_TRIP_BY_ID: (tripId: number | string) => `${TRIPS_URL}/${tripId}`,
    GET_TRIP_READINGS: (tripId: number | string) => `${TRIPS_URL}/range/${tripId}`,
    PATCH_TRIP: (tripId: number | string) => `${TRIPS_URL}/${tripId}`,
    PATCH_TRIP_CHECKLIST: (tripId: number) => `${TRIPS_URL}/${tripId}/checklist`,
    END_TRIP: (tripId: number) => `${TRIPS_URL}/${tripId}`,
    COORDINATES: (legId: number) => `${TRIPS_URL}/coordinates/${legId}`,
    GET_TRIP_HISTORY_BY_LEG_ID: `${TRIPS_URL}/history`,
    GET_ALL_AVAILABLE_SENSORS: BASE_URL + 'transport/api/inventory/getAvailableSensors',
    ADD_TRIP: TRIPS_URL + '/',
}

export const CUSTOMER = {
    // CUSTOMER ENDPOINTS
    CUSTOMER_BY_ID: (id: number) => `${CUSTOMER_URL}/${id}`,
    // LOCATION ENDPOINTS
    LOCATION: CUSTOMER_URL + '/location',
    LOCATION_BY_ID: (id: number) => `${CUSTOMER_URL}/location/${id}`,
    GET_QUICK_LOCATIONS: CUSTOMER_URL + '/quick-location',
    GET_QUICK_LOCATION_BY_ID: (locationId: number | string) => `${CUSTOMER_URL}/quick-location/${locationId}`,

    // LOGISTIC COMPANY ENDPOINTS
    GET_LOGISTIC_COMPANIES: CUSTOMER_URL + '/logistic-company',
    UPDATE_LOGISTIC_COMPANY_BY_ID: (id: number) => `${CUSTOMER_URL}/logistic-company/${id}`,

    // PRODUCT ENDPOINTS
    PRODUCT: CUSTOMER_URL + '/product',
    PRODUCT_BY_ID: (id: number) => `${CUSTOMER_URL}/product/${id}`,

    // MISC ENDPOINTS
    GET_SENSOR_TYPE_OPTIONS: CUSTOMER_URL + '/abbreviations',
    VALIDATE_SENSOR_TYPE_AND_ABBREVIATION: CUSTOMER_URL + '/abbreviations/validate',
    CUSTOMER_CONFIG: CUSTOMER_URL + '/customer-config',
    ALARM: CUSTOMER_URL + '/alarms/',

    // Environment Endpoints
    GET_ENVIRONMENTS: CUSTOMER_URL + '/environment',

    // REASON FOR EXCURSION ENDPOINTS
    REASON_FOR_EXCURSION: CUSTOMER_URL + '/reason',
}

export const DEVICE = {
    STORAGE: {
        DEVICES: DEVICE_URL + '/storage/devices',
        GET_DEVICE_CERTIFICATE: `${DEVICE_URL}/view-calibration-data`,
    },
    TRANSPORT: {
        GET_DEVICES: `${DEVICE_URL}/transport/inventory/`,
        UPDATE_STATUS: (id: string) => `${DEVICE_URL}/transport/inventory/${id}`,
    },
    AQI: {
        GET_AQI_DATA: `${DEVICE_URL}/aqi/`,
    }
}

export const INCIDENTS = {
    REQUEST_EXTENSION: `${INCIDENTS_URL}/handle-extension`,
    TRANSPORT: {
        LIST: `${INCIDENTS_URL}/transport/`,
        GET_CHILD_INCIDENTS: `${INCIDENTS_URL}/transport/child-incidents`,
        UPDATE_ASSIGN_TO: `${INCIDENTS_URL}/transport/assigned-to-user`,
        UPDATE_INCIDENT: (id: string) => `${INCIDENTS_URL}/transport/${id}`,
        BY_ID: (id: string) => `${INCIDENTS_URL}/transport/${id}`,
        FORM_SUBMISSION: `${INCIDENTS_URL}/transport/form-submission`,
        FORM_ACTION: `${INCIDENTS_URL}/transport/form-action`,
        GET_FORM_DATA: `${INCIDENTS_URL}/transport/getFormData`,
        CAPA_FILE_UPLOAD: `${INCIDENTS_URL}/transport/upload-capa-document`,
        GET_HISTORY_DATA_BY_ID: (id: string | number) => `${INCIDENTS_URL}/transport/get-incident-log/${id}`,
        GET_INCIDENT_DETAILS_LOG: (id: string | number) => `${INCIDENTS_URL}/transport/get-incident-details-log/${id}`,
        RESUBMIT_INCIDENT: `${INCIDENTS_URL}/transport/reset-form`,
        GET_RESET_FORM_DATA_BY_LOG_ID: (logId: number) => `${INCIDENTS_URL}/transport/get-reset-form-data/${logId}`,
        SAVE_PRODUCT: `${INCIDENTS_URL}/transport/save-product`,
        COMMENT: `${INCIDENTS_URL}/transport/comments`,
    },
    STORAGE: {
        LIST: `${INCIDENTS_URL}/storage/`,
        BY_ID: (id: string) => `${INCIDENTS_URL}/storage/${id}`,
        UPDATE_INCIDENT: (id: string) => `${INCIDENTS_URL}/storage/${id}`,
        GET_INCIDENT_HISTORY: (id: string | number) => `${INCIDENTS_URL}/storage/log/${id}`,
        GET_INCIDENT_LOG: (id: string | number) => `${INCIDENTS_URL}/storage/detail-log/${id}`,
        GET_FORM_DATA: `${INCIDENTS_URL}/storage/getFormData`,
        FORM_SUBMISSION: `${INCIDENTS_URL}/storage/form-submission`,
        FORM_ACTION: `${INCIDENTS_URL}/storage/form-action`,
        PRODUCT_SAVE: `${INCIDENTS_URL}/storage/update-evalDisProdList`,
        RESUBMIT_INCIDENT: `${INCIDENTS_URL}/storage/reset-form`,
        CAPA_FILE_UPLOAD: `${INCIDENTS_URL}/storage/upload-capa-document`,
        GET_RESET_FORM_DATA_BY_LOG_ID: (logId: number) => `${INCIDENTS_URL}/storage/get-reset-form-data/${logId}`,
        SAVE_PRODUCT: `${INCIDENTS_URL}/storage/save-product`,
        COMMENT: `${INCIDENTS_URL}/storage/comments`,
    }
}

export const USER = {
    GET_ALL_USER: USER_URL + '/',
    CREATE: USER_URL + '/',
    UPDATE: USER_URL + '/',
    GET_BY_ID: USER_URL + '/',
    GET_ROLES: USER_URL + '/roles',
    UPDATE_PASSWORD: USER_URL + '/update-password',
}

export const AUTH = {
    LOGIN: AUTH_URL + '/login',
    GENERATE_OTP: AUTH_URL + '/otp-generate-v2',
    VERIFY_OTP: AUTH_URL + '/otp-verify-v2',
    LOGOUT: AUTH_URL + '/logout',
    VERIFY_PASSWORD: AUTH_URL + '/validate-password',
}

export const ADMIN = {
    CREATE_TICKET: ADMIN_URL + '/addSupportTicket',
    GET_TICKETS: ADMIN_URL + '/getSupportTicket',
    GET_DEMO_VIDEOS: ADMIN_URL + '/getDemoVideo',
}

export const ASSET = {
    CREATE_ASSET: ASSET_URL + '/',
    UPDATE_ASSET: ASSET_URL + '/',
    DECOMMISSION_ASSET: ASSET_URL + '/decommission',
    LIST: ASSET_URL + '/',
    ASSET_BY_LOC: ASSET_URL + '/location',
    BY_ID: (id: string | number) => ASSET_URL + '/' + id,
    FILTERS: ASSET_URL + '/filters',
    GRAPH_BY_DATE: ASSET_URL + '/date-range',
    DOWNLOAD_READINGS: ASSET_URL + '/download-readings',
    SWAP_SENSOR: ASSET_URL + '/swap-sensor',
    ALARM: {
        GET_ALARMS_BY_ASSET: ASSET_URL + '/alarms',
        CREATE_ALARM: ASSET_URL + '/alarms',
        UPDATE_ALARM: (id: string | number) => ASSET_URL + '/alarms/' + id,
        DELETE: (id: string | number) => ASSET_URL + '/alarms/' + id,
    }
}